module.exports = __webpack_public_path__ + "img/1440.27dac2c6.svg";